import * as z from 'zod';
import {translations} from 'presentation/translations-new';
import {AvailabilityEnum} from '../../constants';

const {
	validation: {selectDayOfWeek, selectPeriod},
} = translations['pt-br'].privateFlow.bookingFlow.requestSchedule;

export const requestScheduleSchema = z
	.object({
		availability: z
			.enum([AvailabilityEnum.ANY_DAY, AvailabilityEnum.RESTRICTION])
			.default(AvailabilityEnum.ANY_DAY),
		whatsappUpdates: z.boolean(),
		typeOfConsultation: z.string().optional(),
		morning: z
			.object({
				active: z.boolean(),
				days: z
					.object({
						monday: z.boolean(),
						tuesday: z.boolean(),
						wednesday: z.boolean(),
						thursday: z.boolean(),
						friday: z.boolean(),
						saturday: z.boolean(),
						sunday: z.boolean(),
					})
					.optional(),
			})
			.optional(),
		afternoon: z
			.object({
				active: z.boolean(),
				days: z
					.object({
						monday: z.boolean(),
						tuesday: z.boolean(),
						wednesday: z.boolean(),
						thursday: z.boolean(),
						friday: z.boolean(),
						saturday: z.boolean(),
						sunday: z.boolean(),
					})
					.optional(),
			})
			.optional(),
		night: z
			.object({
				active: z.boolean(),
				days: z
					.object({
						monday: z.boolean(),
						tuesday: z.boolean(),
						wednesday: z.boolean(),
						thursday: z.boolean(),
						friday: z.boolean(),
						saturday: z.boolean(),
						sunday: z.boolean(),
					})
					.optional(),
			})
			.optional(),
	})
	.refine(
		data => {
			if (data.availability === AvailabilityEnum.RESTRICTION && data.morning?.active) {
				return (
					data.morning &&
					data.morning.active !== undefined &&
					Object.values(data.morning?.days || {}).some(day => day === true)
				);
			}
			return true;
		},
		{
			message: selectDayOfWeek,
			path: ['morning'],
		},
	)
	.refine(
		data => {
			if (data.availability === AvailabilityEnum.RESTRICTION && data.afternoon?.active) {
				return (
					data.afternoon &&
					data.afternoon.active !== undefined &&
					Object.values(data.afternoon?.days || {}).some(day => day === true)
				);
			}
			return true;
		},
		{
			message: selectDayOfWeek,
			path: ['afternoon'],
		},
	)
	.refine(
		data => {
			if (data.availability === AvailabilityEnum.RESTRICTION && data.night?.active) {
				return (
					data.night &&
					data.night.active !== undefined &&
					Object.values(data.night?.days || {}).some(day => day === true)
				);
			}
			return true;
		},
		{
			message: selectDayOfWeek,
			path: ['night'],
		},
	)
	.refine(data => {
		if (data.availability === AvailabilityEnum.ANY_DAY) {
			return data.whatsappUpdates !== undefined && data.typeOfConsultation !== undefined;
		}
		return true;
	})
	.refine(
		data => {
			if (data.availability === AvailabilityEnum.RESTRICTION) {
				return (
					data.morning?.active === true ||
					data.afternoon?.active === true ||
					data.night?.active === true
				);
			}
			return true;
		},
		{
			message: selectPeriod,
			path: ['availability'],
		},
	);

type RequestScheduleSchema = z.infer<typeof requestScheduleSchema>;

type ShiftType = RequestScheduleSchema['morning'];

export type {RequestScheduleSchema, ShiftType};
